export const PROD_DOMAIN = "demo.edot-solutions.training.marisafe.sg";

export const LEADERBOARD_PARENT_DROPDOWN = {
  OVERALL: 0,
  RANKS: 1,
  SHIP: 2,
  OFFICE: 3,
  DESIGNATION: 4,
  ONSHORE: 5,
  OFFSHORE: 6,
};

export const COURSE = {
  CONSTANTS: {
    MAX_PROGRESS: 100,
    SHORT_DESCRIPTION_MAX: 160,
    MIN_COURSE_PROGRESS: 50,
    REVIEW_PAGE_SIZE: 5,
    REVIEW_SCROLL_HEIGHT: 200,
  },

  TYPE: {
    SELF_DIRECTED: 1,
    LIVE: 2,
    EXTERNAL: 3,
  },

  REQUIREMENT_TYPE: {
    PRIORITY: 1,
    MANDATORY: 2,
    RECOMMENDED: 3,
  },

  COURSE_EXPIRY_TYPEID: {
    NA: 1,
    MONTH: 2,
    YEAR: 3,
  },

  STATUS: {
    ALL_COURSES: 1,
    COMPLETED_COURSES: 2,
    ASSIGNED_COURSES: 3,
    ONGOING_COURSES: 4,
  },

  PROGRESS_STATUS: {
    ALL: {
      value: 0,
      label: "All",
    },
    PENDING: {
      value: 1,
      label: "Not Started",
      color: "#c8c8c8",
    },
    IN_PROGRESS: {
      value: 2,
      label: "In Progress",
      color: "#FFC107",
    },
    COMPLETED: {
      value: 3,
      label: "Completed",
      color: "#4CAF50",
    },
  },

  QUIZ_STATUS: [
    {
      value: 1,
      label: "Pass",
    },
    {
      value: 2,
      label: "Fail",
    },
  ],

  MSSGS: {
    NOT_FOUND: "No Courses Found",
    NO_ACCESS: "You're not allowed to access this course",
    REVIEW_SUCCESS: "Course has been reviewed successfully",
    CANT_REVIEW: "Complete the course to add review",
    REVIEW_LOAD_ERR: "Error loading reviews",
    COURSE_LOADING: "Page Loading... Please wait.",
  },
};

export const VIDEO = {
  CONSTANTS: {
    DEFT_VOLM: 0.3, // 30%
    PLAY_INTERVAL: 1000,
  },

  CONTENT_TYPE: {
    VIDEO_CIPHER: 1,
    THIRD_PARTY_VIDEO: 2,
  },

  MSSGS: {
    LOAD_ERROR: "Error loading video.",
    LOAD_ERROR_LONG:
      "We apologize for the inconvenience, but it seems that the video you are trying to access is not loading correctly at the moment.",

    QUIZ_FAIL_MSSG:
      "Oops! It looks like you answered incorrectly. Not to worry, learning is all about progress! We encourage you to rewatch the section to reinforce your understanding of the topic. You've got this! Happy learning! Please hit the Restart button to continue.",

    QUIZ_TIMEOUT_MSSG:
      "Question timed out due to inactivity. Please use the buttons below to either restart the section or go back to the home screen",
  },
};

export const USER = {
  STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
    PENDING: 3,
  },

  ROLE: {
    ADMIN: 1,
    CLIENT: 2,
    TRIAL: 3,
    WARTSILA_CLIENT: 4,
    ATTENDEE: 5,
  },

  COURSE_ACCESS: {
    FULL_ACCESS: 1,
    NO_ACCESS: 2,
    CUSTOM_ACCESS: 3,
    TRIAL_ACCESS: 4,
  },

  SUBSCRIPTION_STATUS: {
    SUBSCRIPTION_NOT_STARTED: 1,
    VALID: 2,
    ONE_DAY_LEFT: 3,
    SUBSCRIPTION_ENDED: 4,
  },

  REQUEST_STATUS: {
    PENDING: 1,
    APPROVED: 2,
    DENIED: 3,
  },

  MSSGS: {
    EXISTS: "User is already registered",
    REGISTER_SUCCESS: "User registered successfully",
    REGISTER_FAILED: "User registration failed",
    LOGIN_FAILED: "User login failed",
    NETWORK_ERROR: "Network Error",
    INACTIVE: "You're an Inactive user, please contact admin",
    PENDING:
      "Your account has not yet been activated. Please contact our support team via the contact us page to gain access.",
    UNSUBSCRIBE_SUCCESS:
      "Email unsubscription successful. You won't receive any further emails.",
    UPDATED_SUCESSFULLY_MSG: "User profile updated successfully!",
    FAIL: "Oops!, Something went wrong.",
    PENDING_REQUEST:
      "Your update request has been submitted and awaiting admin approval.",
  },
};

export const FAQ = {
  CONSTANTS: {
    MAX_SHRT_DESC_LEN: 200,
    FEATURED_FAQ_LIMIT: 8,
    PAGE_SIZE: 5,
  },

  MSSGS: {
    LOAD_ERR: "Error loading Faqs",
  },
};

export const MONTHLY_QUIZ = {
  RESULT_STATUS: {
    ANSWERED: 1,
    NOT_ANSWERED: 2,
    COMMING_SOON: 3,
    PENDING_TO_BE_ANSWERED: 4,
  },

  CORRECT_RESULT: [
    "Brilliant! You nailed it!",
    "You're absolutely correct! Way to go!",
    "Hooray! You answered correctly. Keep up the good work!",
    "Correctamundo! You're crushing it!",
    "Congratulations! That's the correct answer. Well done!",
  ],

  INCORRECT_RESULT: [
    "Close, but no cigar. Keep trying, you're making progress!",
    "Incorrect, but don't be discouraged. Learning is a journey!",
    "Uh-oh! That's not correct. Keep pushing, you're improving!",
  ],
};

export const LESSON = {
  TYPE: {
    LESSON_WITH_SUBLESSON: 1,
    LESSON_WITH_CONTENT: 2,
    ASSESSMENT_LESSON: 3,
  },

  CONTENT_TYPE: {
    PARAGRAPH: 1,
    QUOTE: 2,
    ACCORDIAN_LIST: 3,
    VIDEO: 4,
    FLASH_CARD_LIST: 5,
    FLASH_CARD_GRID: 6,
    BLOCK_CAROUSEL: 7,
    SINGLE_CHOICE_QUIZ: 8,
    MULTIPLE_CHOICE_QUIZ: 9,
    ACTION_BUTTON: 10,
    IMAGE: 11,
    SORTING_GAME: 12,
    MATCHING_GAME: 13,
    SCORM: 14,
    DOCUMENT: 15,
    MEETING: 16,
  },

  INTERACTIVE_CONTENT_TYPE: {
    INTRODUCTION: 1,
    CONTENT: 2,
    SUMMARY: 3,
  },

  QUESTION_TYPE: {
    MULTIPLE_CHOICE: 1,
    SINGLE_CHOICE: 2,
  },

  IMAGE_CONTENT_TYPE: {
    CENTRE: 1,
    FULL: 2,
    IMAGE_TEXT: 3,
    TEXT_IMAGE: 4,
  },
};

//#region HEADER MENU

export const HEADER_MENU_DISPLAY_TYPE = {
  NotLoggedIn: 1,
  LoggedIn: 2,
  Both: 3,
};

//#endregion HEADER MENU

export const PLACEHOLDER_IMGS = {
  DEFAULT: "assets/images/placeholder.png",
  ERROR: "assets/images/error-image-placeholder.png",
  PROFILE: "assets/images/profile-dp.jpg",
  PROFILE_CIRCLE: "assets/images/profile-placeholder-circle.jpg",
  PROFILE_ERROR: "assets/images/error-profile.png",
  BACK_BUTTON: "assets/images/backButton.png",
  BANNER_VIDEO_POSTER: "assets/images/st-lms-banner-video-thumbnail.png",
  ERROR_LANDING_BANNER: "assets/images/Landing-Banner-Error-img.png",
};

//#region TOAST, POPUP

export const TOAST_TYPE = {
  Sucess: 1,
  Error: 2,
};

export const COMMON_ACTION_POPUP_TITLE = {
  UnsavedChanges: "Unsaved Changes",
};

//#endregion

export const CLIENT_DASHBOARD_MSSG = {
  IMG_SAVE_SUCCESS: "Profile image saved successfully",
  IMG_DELETE_SUCCESS: "Profile image deleted successfully",
  CROP_IMG: "Please crop the profile image",

  CERT_CREATE_ERR: "Could not generate certificate",
  CERT_DWNLD_SUCCESS: "Certificate downloaded successfully",
  CERT_DWNLD_FAIL: "Could not download certificate",
  CERT_PREV_FAIL: "Could not preview certificate",
  GENERATE_CERT_MSSG: "One moment please...",
  IMG_FORMAT_NOT_SUPPORTED: "Image format not supported",
};

export const CONTACT_US_MSSG = {
  SUCCESS: "Thank you for getting in touch!",
  FAIL: "Oops!, Something went wrong.",
  INVALID: "Please enter valid details.",
};

export const LANDING_PAGE_CONSTANTS = {
  MEDIA_TYPE: {
    IMAGE: 1,
    VIDEO_CIPHER: 2,
  },
};

export const ARCHIVE_ACTIONS = {
  LOGGED_IN: {
    NUMBER: 1,
    DATA: "User Logged In",
  },
  LOGGED_OUT: {
    NUMBER: 2,
    DATA: "User Logged Out",
  },
  REGISTERED: {
    NUMBER: 3,
    DATA: "User Registered",
  },
  VIEWED_COURSE: {
    NUMBER: 4,
    DATA: "User viewed course home page",
  },
  VIEWED_LESSON: 5,
  VIDEO_PLAYED: 6,
  VIDEO_PAUSED: 7,
  VIDEO_STOPPED: 8,
  VIDEO_SKIPPED: 9,
  VIDEO_INIT_ERR: 10,
  WARTSILA_EXERCISE_START: 14,
  WARTSILA_SESSION_START: 15,

  ERROR: "Archive Action Failed",
};

export const ZINDEX_LEVELS = {
  LEVEL_1: Number.MAX_SAFE_INTEGER,
  LEVEL_2: 999_999,
};

export const PAGE_ROUTES = {
  ERRORPAGE: "/ErrorPage",
  COURSES: "/Courses",
  COURSE_MAIN_PAGE: "/Course/Lesson/:guid?",
  COURSE_PREVIEW_PAGE: "/Course/Preview/Lesson/:guid?",
  COURSE_HOME_PAGE: "/Course/:guid?",
  HOME: "/Home",
  CONTACT: "/Contact",
  FAQ: "/Faq",
  TERMSANDCONDITIONS: "/TermsAndConditions",
  PUBLIC_ROUTE: "/",
  LOGIN: "/Login",
  UNSUBSCRIBE: "/Unsubscribe",
  MONTHLY_QUIZ: "/MonthlyQuiz",
  GRANT_USER_ACCESS: "/GrantUserAccess/:userData?",
  PROFILE_PAGE: "/Profile",
  LEADERBOARD: "/Leaderboard",
  TRAINING_LOG_BOOK: "/TrainingLogBook",
  TRAINING_LOG: "/TrainingLog",
  COURSE_CONSOLIDATION: "/CourseConsolidation",
};

export const RATING_TYPE = {
  STRONGLY_DISAGREE: 1,
  DISAGREE: 2,
  AGREE: 3,
  STRONGLY_AGREE: 4,
  NOT_SURE: 5,
};

export const CERTIFICATE_FORM_MSGS = {
  FORMSUBMITTEDSUCESS: "Feedback submitted successfully",
  CONFIRM_POPUP_TITLE: "Submit",
  CONFIRM_POPUP_DESC:
    "Please confirm that the feedback entered is accurate. Once submitted it can no longer be changed.",
  CONFIRM_POPUP_BUTTON_LABLE: "Submit",
};

export const CHART_TIME_SPAN = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
  YEAR: 4,
};

export const TRAINING_LOG_ACCESS = {
  Master: 81,
  CO: 82,
};

export const MeetingSessionStatus = {
  Scheduled: 1,
  Live: 2,
  Ended: 3,
};

export const MeetingUiState = {
  Idle: 1, // user not in meeting
  InCall: 2, // adapter exists
  LeftCall: 3,
};

export const ParticipantEventType = {
  Join: 1,
  Leave: 2,
  Drop: 3,
};
